// extracted by mini-css-extract-plugin
export default {"container":"style_container__Q-9p0","comment":"style_comment__7r+sO","success":"style_success__sRuz3","fail":"style_fail__bXwQQ"};